import { useCallback } from 'react';

// triggers a file download in the browser
interface DownloadOptions {
  filename: string;
  blob: Blob;
}

export const useFileDownload = () => {
  const downloadFile = useCallback(({ filename, blob }: DownloadOptions) => {
    // Create a URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;

    // Append to body, click, and remove
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    // Clean up the URL object
    window.URL.revokeObjectURL(url);
  }, []);

  return { downloadFile };
};
